import React, { Component } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// Components
import Loader from "../../../utils/Loader";
import ErrorWrap from "../../../utils/error-success/ErrorWrap";
import RegisteredReviewerItem from "./RegisteredReviewerItem";
import ConfirmedReviewers from "./ConfirmedReviewers";
import Button from "../../../utils/Button";
import SortableDocumentList from "./SortableDocumentList";
import DocumentsUploader from "../../../utils/DocumentsUploader";
import DeleteConfirmationDialog from "../../../utils/dialogs/DeleteConfirmationDialog";

// CKeditor
import CKEditor from "react-ckeditor-component";
import { editorReady } from "../../../../utils/editor";
import CKEditorInput from "../../../../utils/forms/CKEditorInput";

// CSS
import "../../../../css/forms/datepicker.css";
import "../../../../css/forms/react-select.css";
import "../../../../css/forms/custom-checkbox.css";

import SearchReviewerDialogButton from "../../../utils/dialogs/search-reviewer-dialog";

class ReviewForm extends Component {
	constructor(props) {
		super(props);

		this.state = {
			am_pm_start: ["am", "pm"],
			location: ["On-site", "Virtual"]
		};

		this.CKEditorInput = new CKEditorInput();
	}

	render() {
		const {
			data,
			role,
			errors,
			inProcess,
			organizations,
			organizationsLoading,
			organizationsError,
			sectors,
			sectorsLoading,
			sectorsError,
			documentsInProgress,
			documentsError,
			documentsSuccess
		} = this.props;

		return (
			<React.Fragment>
				<div className="fieldset">
					<div className="fieldset-indent">
						<div className="floated-field-container">
							<div className="form-field half-field">
								<label htmlFor="organization_id">Organizations:</label>

								{organizationsError ? (
									<ErrorWrap>{organizationsError}</ErrorWrap>
								) : organizationsLoading ? (
									<Loader />
								) : (
									<React.Fragment>
										{!!errors.organization_id && (
											<ErrorWrap animate={1}>{errors.organization_id}</ErrorWrap>
										)}

										<Select
											classNamePrefix="react-select"
											placeholder={"Select one"}
											isClearable={false}
											isDisabled={inProcess}
											name={`organization_id`}
											value={organizations.filter(
												({ id }) => id === data.organization_id
											)}
											onChange={({ id }) => {
												this.props.updateSelectedValue(id, "organization_id");
											}}
											options={organizations}
											getOptionLabel={({ title }) => title}
											getOptionValue={({ id }) => id}
										/>
									</React.Fragment>
								)}
							</div>
						</div>

						<div className="floated-field-container">
							<div className="form-field half-field">
								<label>Accreditation Anniversary:</label>

								{!!errors.accreditation_anniversary && (
									<ErrorWrap animate={1}>
										{errors.accreditation_anniversary}
									</ErrorWrap>
								)}
								<DatePicker
									className="date"
									selected={data.accreditation_anniversary}
									disabled={inProcess}
									onChange={e =>
										this.props.handleDateChange(e, "accreditation_anniversary")
									}
									dateFormat="LL"
									placeholderText="Click to select a date"
								/>
							</div>

							<div className="form-field half-field">
								<label>Extended To:</label>

								{!!errors.extended_to && (
									<ErrorWrap animate={1}>{errors.extended_to}</ErrorWrap>
								)}
								<input
									type="text"
									id="extended_to"
									value={data.extended_to}
									maxLength="255"
									disabled={inProcess}
									onKeyPress={e => this.props.handleKeyPress(e)}
									onChange={e => this.props.handleInputChange(e)}
								/>
							</div>
						</div>

						<div className="form-field single-line-checkbox">
							{!!errors.french_aspect_required && (
								<ErrorWrap animate={1}>{errors.french_aspect_required}</ErrorWrap>
							)}
							<div
								className={`custom-label checkbox-label${
									inProcess ? " disabled-label" : ""
								}`}
							>
								<input
									type="checkbox"
									id="french_aspect_required"
									value="1"
									checked={data.french_aspect_required}
									disabled={inProcess}
									onChange={e => this.props.handleCheckboxClick(e)}
								/>
								<label htmlFor="french_aspect_required">French Required</label>
							</div>
						</div>
					</div>
				</div>

				<div className="fieldset">
					<div className="title-label">Ratings</div>

					<div className="fieldset-indent">
						<div className="floated-field-container">
							<div className="form-field half-field">
								<label>Review Team Rating?:</label>

								{!!errors.review_team_rating && (
									<ErrorWrap animate={1}>{errors.review_team_rating}</ErrorWrap>
								)}
								<input
									type="text"
									id="review_team_rating"
									value={data.review_team_rating}
									maxLength="255"
									disabled={inProcess}
									onKeyPress={e => this.props.handleKeyPress(e)}
									onChange={e => this.props.handleInputChange(e)}
								/>
							</div>

							<div className="form-field half-field">
								<label>CCA Support Rating:</label>

								{!!errors.cca_support_rating && (
									<ErrorWrap animate={1}>{errors.cca_support_rating}</ErrorWrap>
								)}
								<input
									type="text"
									id="cca_support_rating"
									value={data.cca_support_rating}
									maxLength="255"
									disabled={inProcess}
									onKeyPress={e => this.props.handleKeyPress(e)}
									onChange={e => this.props.handleInputChange(e)}
								/>
							</div>
						</div>

						<div className="floated-field-container">
							<div className="form-field half-field">
								<label>Accreditation Process Rating:</label>

								{!!errors.accreditation_process_rating && (
									<ErrorWrap animate={1}>
										{errors.accreditation_process_rating}
									</ErrorWrap>
								)}
								<input
									type="text"
									id="accreditation_process_rating"
									value={data.accreditation_process_rating}
									maxLength="255"
									disabled={inProcess}
									onKeyPress={e => this.props.handleKeyPress(e)}
									onChange={e => this.props.handleInputChange(e)}
								/>
							</div>
						</div>
					</div>
				</div>

				<div className="fieldset">
					<div className="title-label">Board Chair</div>

					<div className="fieldset-indent">
						<div className="floated-field-container">
							<div className="form-field half-field">
								<label>Board Chair First Name:</label>

								{!!errors.board_chair_fname && (
									<ErrorWrap animate={1}>{errors.board_chair_fname}</ErrorWrap>
								)}
								<input
									type="text"
									id="board_chair_fname"
									value={data.board_chair_fname}
									maxLength="255"
									disabled={inProcess}
									onKeyPress={e => this.props.handleKeyPress(e)}
									onChange={e => this.props.handleInputChange(e)}
								/>
							</div>
							<div className="form-field half-field">
								<label>Board Chair Last Name</label>

								{!!errors.board_chair_lname && (
									<ErrorWrap animate={1}>{errors.board_chair_lname}</ErrorWrap>
								)}
								<input
									type="text"
									id="board_chair_lname"
									value={data.board_chair_lname}
									maxLength="255"
									disabled={inProcess}
									onKeyPress={e => this.props.handleKeyPress(e)}
									onChange={event => this.props.handleInputChange(event)}
								/>
							</div>
						</div>
						<div className="form-field">
							<label>Board Chair Email</label>

							{!!errors.board_chair_email && (
								<ErrorWrap animate={1}>{errors.board_chair_email}</ErrorWrap>
							)}
							<input
								type="email"
								id="board_chair_email"
								value={data.board_chair_email}
								maxLength="255"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={event => this.props.handleInputChange(event)}
							/>
						</div>
					</div>
				</div>

				<div className="fieldset">
					<div className="title-label">Executive Director</div>

					<div className="fieldset-indent">
						<div className="floated-field-container">
							<div className="form-field half-field">
								<label>Executive Director First Name:</label>

								{!!errors.exec_director_fname && (
									<ErrorWrap animate={1}>{errors.exec_director_fname}</ErrorWrap>
								)}
								<input
									type="text"
									id="exec_director_fname"
									value={data.exec_director_fname}
									maxLength="255"
									disabled={inProcess}
									onKeyPress={e => this.props.handleKeyPress(e)}
									onChange={e => this.props.handleInputChange(e)}
								/>
							</div>
							<div className="form-field half-field">
								<label>Executive Director Last Name</label>

								{!!errors.exec_director_lname && (
									<ErrorWrap animate={1}>{errors.exec_director_lname}</ErrorWrap>
								)}
								<input
									type="text"
									id="exec_director_lname"
									value={data.exec_director_lname}
									maxLength="255"
									disabled={inProcess}
									onKeyPress={e => this.props.handleKeyPress(e)}
									onChange={event => this.props.handleInputChange(event)}
								/>
							</div>
						</div>
						<div className="form-field">
							<label>Executive Director Email</label>

							{!!errors.exec_director_email && (
								<ErrorWrap animate={1}>{errors.exec_director_email}</ErrorWrap>
							)}
							<input
								type="email"
								id="exec_director_email"
								value={data.exec_director_email}
								maxLength="255"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={event => this.props.handleInputChange(event)}
							/>
						</div>
					</div>
				</div>

				<div className="fieldset">
					<div className="title-label">Accreditation Lead</div>

					<div className="fieldset-indent">
						<div className="floated-field-container">
							<div className="form-field half-field">
								<label>Accreditation Lead First Name:</label>

								{!!errors.lead_fname && (
									<ErrorWrap animate={1}>{errors.lead_fname}</ErrorWrap>
								)}
								<input
									type="text"
									id="lead_fname"
									value={data.lead_fname}
									maxLength="255"
									disabled={inProcess}
									onKeyPress={e => this.props.handleKeyPress(e)}
									onChange={e => this.props.handleInputChange(e)}
								/>
							</div>
							<div className="form-field half-field">
								<label>Accreditation Lead Last Name</label>

								{!!errors.lead_lname && (
									<ErrorWrap animate={1}>{errors.lead_lname}</ErrorWrap>
								)}
								<input
									type="text"
									id="lead_lname"
									value={data.lead_lname}
									maxLength="255"
									disabled={inProcess}
									onKeyPress={e => this.props.handleKeyPress(e)}
									onChange={event => this.props.handleInputChange(event)}
								/>
							</div>
						</div>
						<div className="form-field">
							<label>Accreditation Lead Email</label>

							{!!errors.lead_email && (
								<ErrorWrap animate={1}>{errors.lead_email}</ErrorWrap>
							)}
							<input
								type="email"
								id="lead_email"
								value={data.lead_email}
								maxLength="255"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={event => this.props.handleInputChange(event)}
							/>
						</div>
					</div>
				</div>

				<div className="fieldset">
					<div className="title-label">Notes</div>

					<div className="fieldset-indent">
						<div className="form-field">
							<label>Status Notes:</label>

							{!!errors.status_notes && (
								<ErrorWrap animate={1}>{errors.status_notes}</ErrorWrap>
							)}
							<CKEditor
								scriptUrl="/ckeditor/ckeditor.js"
								content={data.status_notes}
								config={{
									toolbar: "None",
									filebrowserBrowseUrl: "/file-browser",
									uploadUrl: process.env.REACT_APP_API_URL + `files`
								}}
								events={{
									instanceReady: editorReady.bind(this),
									change: this.props.editorChange.bind(this, "status_notes")
								}}
								ref={instance => {
									this.CKEditorInput.addEditor("status_notes", instance);
								}}
							/>
						</div>
						<div className="form-field">
							<label>CCA Accreditation Specialist</label>

							{!!errors.cca_manager_specialist && (
								<ErrorWrap animate={1}>{errors.cca_manager_specialist}</ErrorWrap>
							)}
							<input
								type="email"
								id="cca_manager_specialist"
								value={data.cca_manager_specialist}
								maxLength="255"
								disabled={inProcess}
								onKeyPress={e => this.props.handleKeyPress(e)}
								onChange={event => this.props.handleInputChange(event)}
							/>
						</div>
					</div>
				</div>

				<div className="fieldset">
					<div className="title-label">Sectors</div>

					<div className="fieldset-indent">
						<div className="form-field">
							<label>Main Sector:</label>

							{sectorsError ? (
								<ErrorWrap>{sectorsError}</ErrorWrap>
							) : sectorsLoading ? (
								<Loader />
							) : (
								<React.Fragment>
									{!!errors.main_sector && (
										<ErrorWrap animate={1}>{errors.main_sector}</ErrorWrap>
									)}

									<Select
										classNamePrefix="react-select"
										placeholder={"Select one"}
										isClearable={false}
										isDisabled={inProcess}
										name={`main_sector`}
										value={sectors.filter(({ id }) => id === data.main_sector)}
										onChange={({ id }) => {
											this.props.updateSelectedValue(id, "main_sector");
										}}
										options={sectors}
										getOptionLabel={({ title }) => title}
										getOptionValue={({ id }) => id}
									/>
								</React.Fragment>
							)}
						</div>

						<div className="floated-field-container">
							{sectorsError ? (
								<ErrorWrap>{sectorsError}</ErrorWrap>
							) : sectorsLoading ? (
								<Loader />
							) : (
								<div className="form-field pb1">
									<label>Other Sectors:</label>

									{!!errors.sectors && (
										<ErrorWrap animate={1}>{errors.sectors}</ErrorWrap>
									)}

									{!sectors.length ? (
										<ErrorWrap>
											There are no sector options available at the moment.
										</ErrorWrap>
									) : (
										<React.Fragment>
											{Object.keys(sectors).map(key => {
												const { id } = sectors[key];

												// See if this sector is checked off
												const selectedObject = data.other_modules.find(
													sector => {
														return sector.id === id;
													}
												);

												return (
													<div key={key} className="form-field">
														<div
															className={`custom-label checkbox-label${
																inProcess ? " disabled-label" : ""
															}`}
														>
															<input
																type="checkbox"
																id={`other_modules_${key}`}
																value={id}
																checked={!!selectedObject}
																disabled={inProcess}
																onChange={e =>
																	this.props.handleCheckboxClickArray(
																		sectors[key],
																		"other_modules"
																	)
																}
															/>
															<label htmlFor={`other_modules_${key}`}>
																{sectors[key].title + " (" + sectors[key].description + ")"}
															</label>
														</div>
													</div>
												);
											})}
										</React.Fragment>
									)}
								</div>
							)}
						</div>
					</div>
				</div>

				<div className="fieldset">
					<div className="title-label">Site Visit</div>

					<div className="fieldset-indent">
						<div className="form-field">
							<label>Site Visit Notes:</label>

							{!!errors.site_visit_notes && (
								<ErrorWrap animate={1}>{errors.site_visit_notes}</ErrorWrap>
							)}
							<CKEditor
								scriptUrl="/ckeditor/ckeditor.js"
								content={data.site_visit_notes}
								config={{
									toolbar: "None",
									filebrowserBrowseUrl: "/file-browser",
									uploadUrl: process.env.REACT_APP_API_URL + `files`
								}}
								events={{
									instanceReady: editorReady.bind(this),
									change: this.props.editorChange.bind(this, "site_visit_notes")
								}}
								ref={instance => {
									this.CKEditorInput.addEditor("site_visit_notes", instance);
								}}
							/>
						</div>

						<div className="floated-field-container">
							<div className="form-field half-field">
								<label htmlFor="am_pm_start">AM/PM Start:</label>

								{!!errors.am_pm_start && (
									<ErrorWrap animate={1}>{errors.am_pm_start}</ErrorWrap>
								)}

								<Select
									classNamePrefix="react-select"
									placeholder={"Select one"}
									isClearable={false}
									isDisabled={inProcess}
									name={`am_pm_start`}
									value={this.state.am_pm_start.filter(
										val => val === data.am_pm_start
									)}
									onChange={val => {
										this.props.updateSelectedValue(val, "am_pm_start");
									}}
									options={this.state.am_pm_start}
									getOptionValue={val => val}
									getOptionLabel={val => val}
								/>
							</div>
							<div className="form-field half-field">
								<label htmlFor="location">Review Location:</label>

								{!!errors.location && (
									<ErrorWrap animate={1}>{errors.location}</ErrorWrap>
								)}

								<Select
									classNamePrefix="react-select"
									placeholder={"Select Location"}
									isClearable={false}
									isDisabled={inProcess}
									name={`location`}
									value={this.state.location.filter(
										val => val === data.location
									)}
									onChange={val => {
										this.props.updateSelectedValue(val, "location");
									}}
									options={this.state.location}
									getOptionValue={val => val}
									getOptionLabel={val => val}
								/>
							</div>
						</div>

						<div className="floated-field-container">
							<div className="form-field half-field">
								<label>Site Visit Starts:</label>

								{!!errors.site_visit_starts && (
									<ErrorWrap animate={1}>{errors.site_visit_starts}</ErrorWrap>
								)}
								<DatePicker
									className="date"
									selected={data.site_visit_starts}
									disabled={inProcess}
									onChange={e => this.props.handleDateChange(e, "site_visit_starts")}
									dateFormat="LL"
									placeholderText="Click to select a date"
								/>
							</div>

							<div className="form-field half-field">
								<label>Site Visit Ends:</label>

								{!!errors.site_visit_ends && (
									<ErrorWrap animate={1}>{errors.site_visit_ends}</ErrorWrap>
								)}
								<DatePicker
									className="date"
									selected={data.site_visit_ends}
									disabled={inProcess}
									onChange={e => this.props.handleDateChange(e, "site_visit_ends")}
									dateFormat="LL"
									placeholderText="Click to select a date"
								/>
							</div>
						</div>

						<div className="floated-field-container">
							<div className="form-field half-field">
								<label>Team Arrives:</label>

								{!!errors.team_arrives && (
									<ErrorWrap animate={1}>{errors.team_arrives}</ErrorWrap>
								)}
								<DatePicker
									className="date"
									selected={data.team_arrives}
									disabled={inProcess}
									onChange={e => this.props.handleDateChange(e, "team_arrives")}
									dateFormat="LL"
									placeholderText="Click to select a date"
								/>
							</div>

							<div className="form-field half-field">
								<label>Team Departs:</label>

								{!!errors.team_departs && (
									<ErrorWrap animate={1}>{errors.team_departs}</ErrorWrap>
								)}
								<DatePicker
									className="date"
									selected={data.team_departs}
									disabled={inProcess}
									onChange={e => this.props.handleDateChange(e, "team_departs")}
									dateFormat="LL"
									placeholderText="Click to select a date"
								/>
							</div>
						</div>
					</div>
				</div>

				{!!data.id && !!data.reviewers && (
					<div className="fieldset">
						<div className="title-label">Reviewers</div>
						<SearchReviewerDialogButton reviewId={data.id} role={role}/>

						{data.reviewers.registered.length ? (
							data.reviewers.registered.map((reviewer, i) => (
								<RegisteredReviewerItem
									key={i}
									reviewer={reviewer}
									buttons={[
										role === 'manager' ? <React.Fragment></React.Fragment> 
										: <Button
											key={"on-site"}
											text="On-Site"
											clickHandler={() =>
												this.props.addReviewer(reviewer, "on_site")
											}
										/>,
										role === 'manager' ? <React.Fragment></React.Fragment>
										: <Button
											key={"reading"}
											text="Reading"
											clickHandler={() =>
												this.props.addReviewer(reviewer, "reading")
											}
										/>,
										<div
											key="del"
											className="icon-cross"
											onClick={() =>
												this.props.handleReviewerRegisterDeleteFromRegisteredList(
													reviewer
												)
											}
										/>
									]}
								/>
							))
						) : (
							<div className="pb1">No reviewers registered for approval</div>
						)}

						<ConfirmedReviewers
							review={data}
							role={role}
							handleDelete={this.props.handleReviewerRegisterDelete}
						/>
					</div>
				)}

				{/* Only allow documents on existing reviews */}
				{!!data.id && (
					<div className="fieldset">
						<div className="title-label">Review Documents</div>

						<div className="documents-container">
							<SortableDocumentList
								files={data.documents}
								fileParentItem={data}
								transitionDuration={200}
								lockAxis={"y"}
								lockToContainerEdges={true}
								lockOffset={"0%"}
								useDragHandle={true}
								helperClass="active-sort"
								onSortEnd={({ oldIndex, newIndex }) =>
									this.props.onSortEndFiles(oldIndex, newIndex)
								}
								{...this.props}
							/>

							{documentsError && (
								<ErrorWrap animate={1} classes="row-error">
									{documentsError}
								</ErrorWrap>
							)}

							{/* Don't show the uploader for managers */}
							{role === 'manager' ? <React.Fragment></React.Fragment> :
								<DocumentsUploader
									allowMultiple={true}
									loading={documentsInProgress}
									clear={!!documentsSuccess}
									placeholder={"Drag files here"}
									uploadAssetType={"review-documents"}
									addPromise={this.props.handleDocumentPromisePush}
									handleFilesReadyToUpload={this.props.handleFilesReadyToUpload}
									retryHandler={this.props.handleFilesReadyToUpload}
									allowRetry={this.props.allowRetry}
								/>
							}

							<DeleteConfirmationDialog
								show={this.props.showFileDeleteConfirmationDialog}
								deletionInProgress={this.props.deleteItem.deletionInProgress}
								id={this.props.deleteItem.id}
								itemTitle={this.props.deleteItem.title}
								handleDelete={this.props.handleDelete}
								handleClose={this.props.handleFileDeleteDialogClose}
								deleteErrors={this.props.deleteItem.deleteErrors}
								deleteSuccess={this.props.deleteFileSuccess}
							/>
						</div>
					</div>
				)}

				<div className="fieldset">
					<div className="title-label">Full Review</div>

					<div className="form-field single-line-checkbox">
						{!!errors.review_full && (
							<ErrorWrap animate={1}>{errors.review_full}</ErrorWrap>
						)}
						<div
							className={`custom-label checkbox-label${
								inProcess ? " disabled-label" : ""
							}`}
						>
							<input
								type="checkbox"
								id="review_full"
								value="1"
								checked={data.review_full}
								disabled={inProcess}
								onChange={e => this.props.handleCheckboxClick(e)}
							/>
							<label htmlFor="review_full">Review is full</label>
						</div>
					</div>
				</div>

				<div className="fieldset">
					<div className="title-label">Completed</div>

					<div className="form-field single-line-checkbox">
						{!!errors.completed && (
							<ErrorWrap animate={1}>{errors.completed}</ErrorWrap>
						)}
						<div
							className={`custom-label checkbox-label${
								inProcess ? " disabled-label" : ""
							}`}
						>
							<input
								type="checkbox"
								id="completed"
								value="1"
								checked={data.completed}
								disabled={inProcess}
								onChange={e => this.props.handleCheckboxClick(e)}
							/>
							<label htmlFor="completed">Review is completed</label>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default ReviewForm;



// WEBPACK FOOTER //
// ./src/components/admin/reviews/form-components/ReviewForm.js